import { gql } from '@apollo/client';

export const REJECT_CREDIT = gql`
  mutation rejectCredit($creditId: String!, $rejectInfo: String!) {
    rejectCredit(creditId: $creditId, rejectInfo: $rejectInfo) {
      clientId
    }
  }
`;
